<template>
  <vx-card class="mt-base" :title="activityTitle">
    <p class="mb-5">
      Health and Safety are some of the most important aspects of construction work. Construction
      can be one of the most physically demanding industries to work in and we need to do everything
      we can to make sure that we protect ourselves so we can enjoy a long and healthy career.
    </p>
    <p class="mb-5">
      While all sorts of regulations and procedures are in place to help ensure our safety while
      working in the industry, each individual must take some responsibility for ensuring their own
      safety while at work.
    </p>
    <p class="mb-5">
      One of the first steps to ensuring our safety is to recognise where the risks lie for our
      particular job. This helps us to maintain awareness while working and prevent accidents and
      injuries.
    </p>
    <p class="mb-5">
      Use the link below to access the Risk Radar. Though this tool uses data collected from NSW
      only, the relative risks will be similar no matter which state you are in.
    </p>
    <p class="mb-5">
      The Risk Radar helps you search by industry (select “Construction) and job (select the type of
      work withing the construction industry you would like to do) to find out what risks to look
      out for in your future line of work.
    </p>
    <a
      href="https://www.safework.nsw.gov.au/risk-radar"
      target="_blank"
      class="btn btn-secondary btn-size-medium"
      >Open Risk Radar</a
    >

    <p class="my-5">
      Once you’ve searched the risks for your future job, list the various risks in order, from the
      highest risk (1) to the least risk (5), in the spaces below:
    </p>

    <div class="overflow-hidden">
      <p class="float-left" style="padding: 8px 5px 0 0" v-if="isEditable">
        <strong>Type of Work:</strong>
      </p>
      <p class="float-left py-5 pr-2" v-else><strong>Type of Work:</strong></p>
      <text-block v-model="data['question6']" :editable="isEditable" />
    </div>

    <p class="mb-5"><strong>Risks:</strong></p>
    <div v-for="index in 5" :key="index" class="overflow-hidden">
      <p class="float-left" style="padding: 8px 5px 0; width: 20px" v-if="isEditable">
        {{ index }}:
      </p>
      <p class="float-left py-5 pr-2" v-else>{{ index }}:</p>
      <text-block v-model="data['question' + index]" :editable="isEditable" />
    </div>

    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';

export default {
  methods: methods,
  computed: computed,
  inject: inject,
};
</script>
